





import app from "@/app";
import { SXSector } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WSectorAdd extends BaseComponent {
	title = "SX_LANG_SECTOR_ADD";
	loading = false;

	get form() {
		return getForm();
	}
	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			required = [SXSector.COL_NAME, SXSector.COL_DESCRIPTION],
			fv = app.getFormValidator(form, required);

		if (fv.validate()) {
			let formData = fv.getFormData(),
				customData = {
					bg_color: fv.getField("bg_color"),
					txt_color: fv.getField("txt_color")
				};

			if (!fv.getField(SXSector.COL_VISIBILITY)) {
				formData.append(SXSector.COL_VISIBILITY, "0");
			}

			formData.append(SXSector.COL_DATA, JSON.stringify(customData));

			app.services.sectors.add(formData, function() {
				app.router.goBack();
			});
		}
	}
}

const getForm = function() {
	return {
		fields: {
			name: {
				field: "input",
				label: { i18n: "SX_LANG_NAME" },
				attrs: {
					name: SXSector.COL_NAME,
					minlength: 3,
					maxlength: 60,
					autocomplete: "off"
				}
			},
			description: {
				field: "textarea",
				label: { i18n: "SX_LANG_DESCRIPTION" },
				attrs: {
					name: SXSector.COL_DESCRIPTION,
					minlength: 3
				}
			},
			bg_color: {
				field: "input",
				label: { i18n: "SX_LANG_BG_COLOR" },
				attrs: {
					name: "bg_color",
					type: "color",
					value: "#233D7D"
				}
			},
			txt_color: {
				field: "input",
				label: { i18n: "SX_LANG_TXT_COLOR" },
				attrs: {
					name: "txt_color",
					type: "color",
					value: "#FFFFFF"
				}
			},
			visibility: {
				field: "checkbox",
				label: { i18n: "SX_LANG_VISIBILITY" },
				attrs: {
					name: SXSector.COL_VISIBILITY
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
